import React, {useCallback, useEffect, useMemo} from 'react';
import {selectGuiState} from "./Redux/gui";
import {useDispatch, useSelector} from "react-redux";
import {createTheme, CssBaseline, ThemeProvider} from "@mui/material";
import {getThemeOptions} from "./Config/theme";
import {setUserEmail} from "./Redux/gui";
import {jwtDecode} from "jwt-decode";
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import {routes} from 'Config/routes'
import {useKeycloak} from "./Keycloak/useKeycloak";

function App() {
    const { themeMode } = useSelector(selectGuiState)

    const dispatch = useDispatch()

    const { keycloak } = useKeycloak()

    const theme = useMemo(
        () => createTheme(getThemeOptions(themeMode)),
        [themeMode]
    )

    const router = createBrowserRouter(routes)

    const updateUserEmail = useCallback(() => {

        if (keycloak?.authenticated) {
            const decoded_token = jwtDecode(keycloak.token, {header: false})

            const email = JSON.parse(JSON.stringify(decoded_token))['email']

            dispatch(setUserEmail(email))
        }

    }, [dispatch, keycloak?.authenticated, keycloak.token])

    const checkCustomerNumber = useCallback(() => {
        if (keycloak?.authenticated) {
            const decoded_token = jwtDecode(keycloak.token, {header: false})

            const customer = JSON.parse(JSON.stringify(decoded_token))['customer']

            if (customer?.number == null) {
                keycloak.logout();
                window.alert('Customer Number required')
            }
        }
    }, [keycloak])

    useEffect(() => {
        checkCustomerNumber();
        updateUserEmail();

    }, [checkCustomerNumber, updateUserEmail])

      return (
          <ThemeProvider theme={theme}>
              <CssBaseline enableColorScheme />
              <RouterProvider router={router} />
          </ThemeProvider>
      );
}

export default App;
